import {Stack} from '@mui/material';
import React from 'react';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {ProviderCheckbox} from './ProviderCheckbox';
import {ProviderListProps} from './types';

export const ProviderList = ({providers, selectedIds, onChange}: ProviderListProps) => (
	<Stack spacing={2} p={2}>
		{providers.map(provider => (
			<ProviderCheckbox
				dataTagId={`${AutoSolEnum.CLICK_SELECIONAR_PRESTADOR_AUTOSOL}_${provider.cdPrestador}`}
				key={provider?.idUnico}
				provider={provider}
				selected={selectedIds.includes(provider?.idUnico)}
				onChange={onChange}
			/>
		))}
	</Stack>
);
